import React, { OptgroupHTMLAttributes } from 'react';

export interface GroupProps extends OptgroupHTMLAttributes<HTMLOptGroupElement> {}

function Group(props: GroupProps) {
  const { className, style, children, ...otherProps } = props;

  return <optgroup {...otherProps}>{children}</optgroup>;
}

Group.displayName = 'Group';

export default Group;
